export default function WhatsAppFloat() {
  return (
    <a
      href="https://wa.me/558534942701"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar pelo WhatsApp"
      className="fixed bottom-24 lg:bottom-8 right-4 lg:right-8 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-xl shadow-[#25D366]/30 hover:scale-110 transition-transform duration-300 cursor-pointer"
    >
      <i className="ri-whatsapp-line text-2xl"></i>
    </a>
  );
}